// src/context/CartContext.jsx
import React, { createContext, useContext, useState, useEffect } from 'react';

const CartContext = createContext();

export function CartProvider({ children }) {
    // 从 localStorage 恢复购物车数据
    const [cartItems, setCartItems] = useState(() => {
        try {
            const saved = localStorage.getItem('woodendiary_cart');
            return saved ? JSON.parse(saved) : [];
        } catch {
            return [];
        }
    });

    // 保存到 localStorage
    useEffect(() => {
        localStorage.setItem('woodendiary_cart', JSON.stringify(cartItems));
    }, [cartItems]);

    // 添加商品到购物车
    const addToCart = (product, quantity = 1) => {
        setCartItems(prev => {
            const existingItem = prev.find(item => item.id === product.id);
            if (existingItem) {
                return prev.map(item =>
                    item.id === product.id
                        ? { ...item, quantity: item.quantity + quantity }
                        : item
                );
            }
            return [...prev, { ...product, quantity }];
        });
    };

    // 从购物车移除商品
    const removeFromCart = (productId) => {
        setCartItems(prev => prev.filter(item => item.id !== productId));
    };

    // 更新商品数量
    const updateQuantity = (productId, quantity) => {
        if (quantity <= 0) {
            removeFromCart(productId);
            return;
        }
        setCartItems(prev =>
            prev.map(item =>
                item.id === productId
                    ? { ...item, quantity }
                    : item
            )
        );
    };

    // 清空购物车
    const clearCart = () => {
        setCartItems([]);
    };

    // 计算总数量
    const cartCount = cartItems.reduce((sum, item) => sum + item.quantity, 0);

    // 计算总价格
    const cartTotal = cartItems.reduce((sum, item) => sum + (item.price * item.quantity), 0);

    return (
        <CartContext.Provider value={{
            cartItems,
            cartCount,
            cartTotal,
            addToCart,
            removeFromCart,
            updateQuantity,
            clearCart
        }}>
            {children}
        </CartContext.Provider>
    );
}

export function useCart() {
    const context = useContext(CartContext);
    if (!context) {
        throw new Error('useCart must be used within a CartProvider');
    }
    return context;
}
